import { memo } from 'react';
import { useField, useFormikContext } from 'formik';

import { CommandGroup, CommandItem } from '@src/design-system/command';
import { deduplicateArr } from '@shared/utils/helpers/deduplicate-arr';

import type { TLocale } from '@shared/types/locale';
import { PopoverClose } from '@src/design-system/popover';

export const Currencies = memo(
  ({ name, currencies }: { name: string; currencies: TLocale[] }) => {
    const { setFieldValue } = useFormikContext();
    const [selectFieldProps] = useField(name);

    return (
      <CommandGroup>
        {deduplicateArr(currencies, 'currency_code')?.map((curr) => {
          const isSelected = selectFieldProps.value === curr.currency_code;
          return (
            <PopoverClose
              key={curr.id}
              className='flex flex-col w-full'
            >
              <CommandItem
                isSelected={isSelected}
                value={curr.currency_code}
                onSelect={() => {
                  setFieldValue(name, curr.currency_code);
                }}
              >
                {curr.currency_code}
              </CommandItem>
            </PopoverClose>
          );
        })}
      </CommandGroup>
    );
  }
);
